import BigNumber from "bignumber.js";
import { DEFAULT_VALUE } from "@/config";

export const fmtNum = (num?: number | string) => {
    if (num === undefined || num === null || new BigNumber(num).isNaN()) return DEFAULT_VALUE;
    const bigNum = new BigNumber(num);
    // 检查是否是小数
    if (bigNum.decimalPlaces() && bigNum.decimalPlaces()! > 0) {
        // 是小数，保留两位小数
        const bigNum = new BigNumber(num);
        return bigNum.toFormat(2);
    } else {
        // 是整数，不添加小数位
        const bigNum = new BigNumber(num);
        return bigNum.toFormat();
    }
};
